import { render } from "./IdCheckPage.vue?vue&type=template&id=5f5b2e3a&scoped=true"
import script from "./IdCheckPage.vue?vue&type=script&lang=js"
export * from "./IdCheckPage.vue?vue&type=script&lang=js"

import "./IdCheckPage.vue?vue&type=style&index=0&id=5f5b2e3a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f5b2e3a"]])

export default __exports__